<template>
	<v-container class="mt-12 pt-8" style="background:#fafafa;">
		<v-row style="background:#fafafa;">
			<v-col cols="12" class="pa-0">
				<v-row class="py-1 px-5">
					<v-col cols="12" md="12" LeadsPannel>
						<v-row>
							<v-col cols="12" LEADSPANEL>
								<v-card :loading="loading">
									<v-card-text class="py-0">
										<v-row class="align-center">
											<v-col cols="12">
												<v-row class="align-center">
													<v-col cols="2" class="text-center" TITLE>
														<v-icon size="40" color="secondary">description</v-icon>
													</v-col>
													<v-col cols="10" TITLE>
														<div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">{{i18n['purchaseOrders']}}</div>
														<div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">
														</div>
													</v-col>
												</v-row>
											</v-col>
											<v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
												<Search :appliedFilters="appliedFilters" :resourceSettings="resourceSettings" @createResource="createResource" @searchResource="loadResource()" />
											</v-col>
											<v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                        <Filters :filters="filters" :appliedFilters="appliedFilters" :resource="resource" />
											</v-col>
											<v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">
												<v-btn color="primary" @click="loadResource()" block :class="`${arabic?'arFont':'enFont'}`">
													{{i18n.filter_results}}
												</v-btn>
											</v-col>
											<v-col cols="12" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">
												<v-btn color="success" block @click="videoDialog = true">{{i18n['intro_video']}}</v-btn>
												<VideoDialog @close="closeVideoDialog" :dialog="videoDialog">
      										<iframe src="https://drive.google.com/file/d/1eJ-dpN6pTTqr1MTHJH70vEVx8KjQD0zy/preview" width="100%" height="540" allow="autoplay"></iframe>
												</VideoDialog>
											</v-col>
											<v-col cols="12" md="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
												<Paging :resourceSettings="resourceSettings" :resource="resource" @createResource="createResource"
													@loadResource="loadResource" @pageByNumber="pageByNumber" />
											</v-col>
											<v-col cols="12" class=" py-0">
												<v-row>
													<v-col cols="12" md="6" v-for="(item, index) in resource.data" :key="'item-'+ index">
														<Item :item="item" :index="index" />
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Paging from '../components/Paging.vue';
import Item from './PurchaseOrder/Item.vue'
import Filters from '../components/Filters.vue'
import Search from '../components/Search.vue'
import VideoDialog from '../components/VideoDialog.vue';

export default {
	components: {
		Paging,
    Item,
    Filters,
		Search,
		VideoDialog
	},
	data() {
		return {
			loading: false,
			resourceSettings: {
				createResource: true,
				resourceName: null,
				search: true,
				create: true,
				pagination: true,
			},
			resource: {},
			filters:[
				{type:'date', label:'from_date', key:'from_date'},
				{type:'date', label:'to_date', key:'to_date'},
				{type:'select', label:'status', key:'status_id', items:'statuses'},
				{type:'select', label:'destination', icon:'public', key:'destination', items:'all_countries'},
				{type:'select', label:'account', key:'account_id', items:'accounts', roles:["master"]},
				{type:'switch', label:'accepted_quotation', key:'accepted_quotation'},
				{type:'switch', label:'no_accepted_quotation', key:'no_accepted_quotation'},
				{type:'switch', label:'quotation_price', key:'quotation_price'},
				{type:'switch', label:'no_quotation_price', key:'no_quotation_price'},
				{type:'switch', label:'has_new_messages', key:'has_new_messages'},
				{type:'switch', label:'not_fully_paid', key:'not_fully_paid'},
			],
			appliedFilters:{},
			search:null,
			videoDialog:false,
		}
	},
	methods: {
		closeVideoDialog(){
			this.videoDialog = false
		},
		editItem(item) {
			this.$router.push(`/purchase-order/${item.id}/edit`)
		},
		async deleteItem(item) {
			this.loading = true
			this.$store.dispatch('deleteResource', { resource: `/purchase-orders/${item.id}` })
			this.loading = false

			await this.loadResource()
		},
		clipboardSuccessHandler({ value, event }) {
			this.$emit('clipboardSuccessHandler', { value, event });
		},
		async loadResource(page = 1) {
			this.loading = true
			


			this.resource = await this.$store.dispatch('getResource', { resource: `/purchase-orders?page=${page}`, filters:this.appliedFilters })
			this.resource.statuses = this.resource.statuses.map(x=>{return{...x, label:`po_${x.label}`}})
			this.resource.all_countries = this.all_countries
			this.resourceSettings.createResource = this.resource.create_po
			this.resourceSettings.create = this.resource.create_po
			this.loading = false
		},
		async pageByNumber(page) {
			await this.loadResource(page)
		},
		createResource() {
			this.$router.push('/purchase-order/create')
		}
	},
	computed: {
		i18n() {
			return this.$store.state.i18n[this.$store.state.language]
		},
		arabic() {
			if (this.$store.state.language == 'ar') return true
		},
		master() {
      return this.$store.state.user.role == 'master';
    },
		language(){
      return this.$store.state.language
    },
		all_countries() {
      const keys = Object.keys(this.$store.state.countries_[this.language])
      const values = Object.values(this.$store.state.countries_[this.language])
      const countries = values.map((val, i)=>{
        return {
          text: val, id:keys[i]
        }
      })
      return countries || []
    }
	},
	async mounted(page = 1) {
		await this.loadResource()
	}
}
</script>